import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { setDropDownArray } from '../../../redux/dropdownSlice';
import { genreList, eventTypeList } from '../../../services/api';


export default ()=> {
    const dropdownReducer = useSelector((state) => state.root.dropdownReducer);
    const dispatch = useDispatch();
    //Get approver dropdown array from Server
    // const [genre, setgenre] = useState(dropdownReducer.genre);
    const [eventType, setEventType] = useState(dropdownReducer.event_type)

 
     const { data: eventTypeData, isLoading: eventTypeLoading, refetch: refetchEventType } = useQuery( ["eventType"],
                                            () => eventTypeList(),
                                            { enabled: (dropdownReducer.event_type.length == 0 || dropdownReducer.event_type_filter.length == 0 ), retry: false }
                                         )                                            

    useEffect(() => {
        if (eventTypeData) {
            var temArr = eventTypeData?.data?.event_types?.map((type)=> { 
                return {...type, checked: false} 
            })
            temArr.unshift({id:0,  value:"View-All", checked:true})
            // console.log("event type", dropdownReducer.event_type)
            // console.log("event type list", dropdownReducer.event_type.length)
           dispatch(setDropDownArray({event_type: eventTypeData?.data?.event_types, event_type_filter: temArr }))
          // setgenre(genreData?.data?.genre)
        }
    }, [eventTypeData])


    const selectedEventType = (id) => {
        if (dropdownReducer.event_type.length > 0 && dropdownReducer.event_type.find((item)=> item.id == id) ) {
            return dropdownReducer.event_type.find((item)=> item.id == id)
        } else {
            return {}
        }
    };
  
    return [dropdownReducer.event_type, selectedEventType]  
}